(function (app) {

    app.provider("lifeAccountApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.get = function (lifeAccountId) {
                            return crmApiGateway.get("/LifeAccounts/" + lifeAccountId);
                        }

                        service.getLifeAccounts = function () {
                            return crmApiGateway.getArray("/LifeAccounts");
                        }

                        service.getCaseLifeAccounts = function (caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/LifeAccounts");
                        }

                        service.getCaseLifeAccountsComplete = function (caseId) {
                            return crmApiGateway.getArray("/Cases/" + caseId + "/LifeAccounts/Complete");
                        }

                        service.update = function (lifeAccountId, lifeAccount) {
                            return crmApiGateway.put("/LifeAccounts/" + lifeAccountId, lifeAccount);
                        }

                        service.create = function (lifeAccount) {
                            return crmApiGateway.post("/LifeAccounts", lifeAccount);
                        }

                        return service;
                    }
                ];
            }
        ]);

})(window.app); //jshint ignore:line